
function WialonError4() {

    return(
        <>Invalid input </>
    )
}
export default WialonError4
